import { WHATSAPP_NUMBER, URGENCY_KEYS } from "../data";

/**
 * Helpers used by the /free-screening lead form + countdown/sticky CTA.
 * Pure functions only — no React, no DOM beyond `localStorage`. Keeps
 * the page entrypoint free of business logic.
 */

export function toneStyles(tone) {
  if (tone === "ok") {
    return {
      bar: "bg-[#14B8A6]",
      chip: "bg-[#14B8A6]/15 text-[#0f766e]",
      soft: "bg-[#F0FDFA]",
      border: "border-[#14B8A6]/30",
      text: "text-[#0f766e]",
    };
  }
  if (tone === "warn") {
    return {
      bar: "bg-[#F4C430]",
      chip: "bg-[#F4C430]/25 text-[#92651a]",
      soft: "bg-[#FFFBEB]",
      border: "border-[#F4C430]/40",
      text: "text-[#92651a]",
    };
  }
  return {
    bar: "bg-rose-500",
    chip: "bg-rose-100 text-rose-700",
    soft: "bg-rose-50",
    border: "border-rose-200",
    text: "text-rose-700",
  };
}

// Slots derived from current hour on a 12-hour clock: slots = 17 - hour12.
// Range: 5..16, changes every hour.
export function computeSlots() {
  const h24 = new Date().getHours();
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return 17 - h12;
}

export function pad2(n) {
  return n < 10 ? `0${n}` : `${n}`;
}

export function readUrgencyState() {
  try {
    const now = Date.now();
    let deadline = parseInt(localStorage.getItem(URGENCY_KEYS.deadline) || "0", 10);
    let cycle = parseInt(localStorage.getItem(URGENCY_KEYS.cycle) || "0", 10);
    if (!deadline || deadline <= now) {
      // Alternate 3 -> 5 -> 3 -> 5 days
      const days = cycle % 2 === 0 ? 3 : 5;
      deadline = now + days * 24 * 60 * 60 * 1000;
      cycle = (cycle + 1) % 2;
      localStorage.setItem(URGENCY_KEYS.deadline, String(deadline));
      localStorage.setItem(URGENCY_KEYS.cycle, String(cycle));
    }
    return { deadline, slots: computeSlots() };
  } catch {
    return { deadline: Date.now() + 3 * 24 * 60 * 60 * 1000, slots: computeSlots() };
  }
}

export function buildWhatsAppLink(lead) {
  const lines = [
    "Hello Dr. Dipak,",
    "I have completed the Kiddo+ Free Developmental Screening form.",
    "",
    `Parent Name: ${lead.parent_name}`,
    `Child Name: ${lead.child_name}`,
    `Child Age: ${lead.child_age}`,
    `Main Concern: ${lead.main_concern}`,
    `Diagnosis: ${lead.diagnosis || "—"}`,
    `Phone Number: ${lead.phone_number}`,
    "",
    "I would like guidance regarding my child.",
    "Thank you.",
  ];
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(lines.join("\n"))}`;
}
